// extracted by mini-css-extract-plugin
module.exports = {"files":"files__1rTO8","header":"header__39Eb-","overlay":"overlay__2po-6","big":"big__HJxNg"};